import { https } from './api'

export default class {
    constructor() {
        this.instance = https('/person')
    }

    getPerson = (cpf, rg, courseId, searchType) => {
        return this.instance({
            method: 'GET',
            url: `/${cpf}/${rg}/${courseId}/${searchType}`
        });
    }

    getCoursesByRA = (ra) => {
        return this.instance({
            method: 'GET',
            url: `/${ra}/courses`
        });
    }

    checkApproval = (ra, disciplineId, qualificationId) => {
      return this.instance({
        method: 'GET',
        url: `/${ra}/${disciplineId}/${qualificationId}`
      })
    }

    newPerson = (data) => {
        return this.instance({
            method: 'POST',
            url: '/',
            timeout: 240000,
            data
        });
    }

    newClientPerson = (data) => {
        return this.instance({
            method: 'POST',
            url: '/client',
            timeout: 240000,
            data
        });
    }

    newStudentPerson = (data) => {
        return this.instance({
            method: 'POST',
            url: '/student',
            data
        });
    }
}
